import { useUi } from '../store/uiStore';

export function Toasts() {
  const toasts = useUi((s) => s.toasts);
  return (
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`glass glass--pill toast${t.kind === 'error' ? ' toast--err' : ''}`}>{t.text}</div>
      ))}
    </div>
  );
}
